export default __webpack_public_path__ + "static/media/picture.676a053d.svg";